@use 'sass:math';
@import '../../shared/frame';

$size: 10vw;

.outer {
  background-color: #44cc84;
  color: #fff;
}

.inner {
  padding: 5rem;
}

.countdown-component {
  width: $size * 1.1;
}

.countdown-big {
  font-size: $size;
  font-weight: 900;
}

.countdown-medium {
  font-size: math.div($size, 2);
  font-weight: 900;
}

.countdown-small {
  font-size: math.div($size, 5);
  font-weight: 900;
  text-transform: uppercase;
}

.title {
  font-size: 2rem;
}
